"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_edit_text_1 = require("react-edit-text");
var PropTypes = __importStar(require("prop-types"));
// Local imports
var Icon_1 = require("../Icon");
var ListToggle_1 = require("../ListToggle");
var Panel_1 = require("../Panel");
var PanelCell_1 = require("../PanelCell");
var helpers_1 = require("../../utils/helpers");
var Popup_1 = require("../Popup");
var Toggle_1 = require("../Toggle");
var propTypes = {
    id: PropTypes.number,
    isExpanded: PropTypes.bool,
    label: PropTypes.string.isRequired,
    onDelete: PropTypes.func,
    onLabelChange: PropTypes.func,
    onLabelBlur: PropTypes.func,
    children: PropTypes.node.isRequired,
    mods: PropTypes.string,
    groupHelperText: PropTypes.string || PropTypes.node,
    hasError: PropTypes.bool,
    onExpandedChange: PropTypes.func,
    testId: PropTypes.string,
    deleteDisabled: PropTypes.bool,
    deleteTooltipText: PropTypes.string,
    onToggle: PropTypes.func,
    toggleValue: PropTypes.bool,
    toggleTooltipText: PropTypes.string,
};
var ExpandableGroup = function (_a, ref) {
    var id = _a.id, isExpanded = _a.isExpanded, label = _a.label, onDelete = _a.onDelete, onLabelChange = _a.onLabelChange, onLabelBlur = _a.onLabelBlur, children = _a.children, mods = _a.mods, groupHelperText = _a.groupHelperText, onExpandedChange = _a.onExpandedChange, testId = _a.testId, deleteDisabled = _a.deleteDisabled, deleteTooltipText = _a.deleteTooltipText, onToggle = _a.onToggle, toggleValue = _a.toggleValue, toggleTooltipText = _a.toggleTooltipText;
    var _b = React.useState(false), error = _b[0], setError = _b[1];
    React.useEffect(function () {
        if (label.length > 0) {
            setError(false);
        }
    }, [label]);
    var styles = {
        marginLeft: 10,
        paddingLeft: 4,
        width: '314px',
        background: '#FFFFFF',
        borderRadius: '5px',
        border: '1px solid inherit',
    };
    if (error) {
        styles = __assign(__assign({}, styles), { border: '1px solid #D63333' });
    }
    var className = (0, helpers_1.getClassName)('expandable-group', error && 'u-padBottomSm', mods);
    var deleteIconWithoutTooltip = (React.createElement(Icon_1.Icon, { testId: "ExpandableGroup--delete-".concat(testId), mods: "".concat(deleteDisabled ? 'u-colorNeutral5' : 'expandable-group--trash u-colorNegative4'), name: "trash", style: {
            width: 24,
            height: 24,
            cursor: deleteDisabled ? 'not-allowed' : 'pointer',
        } }));
    var deleteIconWithTooltip = (React.createElement(Popup_1.PopupTooltip, { text: deleteTooltipText }, deleteIconWithoutTooltip));
    var toggleWithoutTooltip = (React.createElement(Toggle_1.Toggle, { testId: "ExpandableGroup--toggle-".concat(testId), inputProps: { onChange: onToggle, checked: toggleValue } }));
    var toggleWithTooltip = (React.createElement(Popup_1.PopupTooltip, { text: toggleTooltipText }, toggleWithoutTooltip));
    return (React.createElement(Panel_1.Panel, { mods: className, testId: testId },
        React.createElement(PanelCell_1.PanelCell, { mods: "u-flex u-flexAlignItemsCenter u-flexJustifyBetween" },
            React.createElement("div", { className: "u-size7of12 u-flex u-flexAlignItemsCenter u-flexAlignContentCenter" },
                React.createElement("div", { className: "expandable-group--carat" },
                    React.createElement(ListToggle_1.ListToggle, { isExpanded: isExpanded, onClick: function () { return onExpandedChange(id); } })),
                React.createElement("div", { style: { position: 'relative' }, ref: ref }, onLabelChange ? (React.createElement(React.Fragment, null,
                    React.createElement(react_edit_text_1.EditText, { className: "u-fontSize1x u-textBold u-spaceLeftSm", value: label, inline: true, onChange: function (e) { return onLabelChange(e.target.value); }, onBlur: function () {
                            if (onLabelBlur) {
                                onLabelBlur();
                            }
                            if (label.length === 0) {
                                setError(true);
                            }
                            else {
                                setError(false);
                            }
                        }, style: styles }),
                    error ? (React.createElement("span", { style: { position: 'absolute', top: 30, left: 8 }, className: "u-colorNegative" }, "You must enter a name for the group.")) : (''))) : (React.createElement("button", { type: "button", className: "u-fontSize1x u-textBold u-spaceLeftSm u-borderNone u-padNone", style: { backgroundColor: 'transparent', cursor: 'pointer' }, onClick: function () { return onExpandedChange(id); } }, label)))),
            !isExpanded && groupHelperText && (React.createElement("div", { className: "u-size4of12 u-flex u-flexJustifyEnd u-colorNeutral7" }, groupHelperText)),
            (onToggle || onDelete) && (React.createElement("div", { className: "u-flex u-spaceLeftLg" },
                onToggle ? React.createElement(React.Fragment, null, toggleTooltipText ? toggleWithTooltip : toggleWithoutTooltip) : null,
                onDelete ? (React.createElement("div", { onKeyDown: function () { }, role: "button", tabIndex: 0, className: "u-size12of12 u-flex u-flexJustifyEnd ".concat(onToggle ? 'u-spaceLeftLg' : ''), onClick: deleteDisabled ? function () { } : onDelete }, deleteTooltipText ? deleteIconWithTooltip : deleteIconWithoutTooltip)) : null))),
        isExpanded && children));
};
exports.default = React.forwardRef(ExpandableGroup);
